query CurrentUserProfile {
  currentUserProfile {
    id
    _rowTimestamp
    name
    defaultAppRouter
    _isUserSignatureUpdatable
    _userSignatureEntityDocumentId
    isAdministrator
    departmentId
    signatureDocument {
      id
      _downloadLink
      fileReference
    }
    company {
      currency {
        isoCode
      }
    }
  }
}
